const routes = [
    {
        path: "/certificates/application/login",
        component: () => import("../pages/Login.vue"),
    },
    {
        path: "/certificates/application/register",
        component: () => import("../pages/Register.vue"),
    },
    {
        path: "/certificates/application/form",
        component: () => import("../pages/ApplicationForm.vue"),
    }
];

export default routes;
